module.exports = __webpack_public_path__ + "img/dollar sign.fa1651fb.svg";